/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedProductAdWrapper_viewer = {
    readonly isTradeDoubleClickAdsOnSbDisabled: boolean | null;
    readonly " $refType": "SbSharedProductAdWrapper_viewer";
};
export type SbSharedProductAdWrapper_viewer$data = SbSharedProductAdWrapper_viewer;
export type SbSharedProductAdWrapper_viewer$key = {
    readonly " $data"?: SbSharedProductAdWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedProductAdWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedProductAdWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isTradeDoubleClickAdsOnSbDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableTradeDoubleClickAdsOnSB"
        }
      ],
      "storageKey": "isEnabled(key:\"disableTradeDoubleClickAdsOnSB\")"
    }
  ]
};
(node as any).hash = 'e7f40c87e68491e869090bd2f6ecf869';
export default node;
